module.exports = __webpack_public_path__ + "static/media/drumstick.7f93c36b.svg";